function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "250",
  height: "160"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".25"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f5f6f8",
  d: "M135.81 105.18v-8L127 95a20.74 20.74 0 00-2.4-5.8l4.68-8-5.44-5.44-8 4.68A21.22 21.22 0 00110 78l-2.2-8.84h-8L97.61 78a21.48 21.48 0 00-5.8 2.4l-8-4.68-5.44 5.44 4.68 8a21.35 21.35 0 00-2.4 5.8l-8.84 2.2v8l8.84 2.2a21.35 21.35 0 002.4 5.8l-4.68 8 5.44 5.44 8-4.68a21.48 21.48 0 005.8 2.4l2.2 8.84h8l2.2-8.84a21.22 21.22 0 005.8-2.4l8 4.68 5.44-5.44-4.68-8a20.74 20.74 0 002.4-5.8zm-32 8a12 12 0 1112-12 12 12 0 01-12 12z",
  "data-name": "16x16"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "16x16"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f5f6f8",
  d: "M178.12 49.43L175.06 42l-9 1.36a21 21 0 00-4.44-4.36l1.26-9.19-7.11-2.94-5.6 7.38a21 21 0 00-6.28 0l-5.41-7.33-7.39 3.06 1.35 9a21 21 0 00-4.44 4.41l-9.18-1.26-2.95 7.1 7.39 5.6a21 21 0 000 6.28l-7.33 5.42 3.07 7.39 9-1.35a21.24 21.24 0 004.44 4.43l-1.26 9.18 7.11 2.94 5.6-7.38a21.25 21.25 0 006.27 0l5.42 7.32L163 86l-1.35-9a21 21 0 004.44-4.44l9.18 1.27 2.95-7.11-7.39-5.6a21.32 21.32 0 000-6.28zm-26.5 19.63a12 12 0 116.49-15.68 12 12 0 01-6.49 15.68z",
  "data-name": "settings"
})))));